import { useStarterPreview } from '@/features/onboarding';
import type { StarterPreviewMember } from '@/features/onboarding';
import styles from './StarterPreviewPanel.module.css';

interface Props {
  departmentIds: string[];
}

export function StarterPreviewPanel({ departmentIds }: Props) {
  const { data, isPending } = useStarterPreview(departmentIds);
  const members = data?.members ?? [];

  if (departmentIds.length === 0) {
    return (
      <div className={styles.panel}>
        <p className={styles.label}>Your team preview</p>
        <div className={styles.pills}>
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
          <div className={styles.placeholder} />
        </div>
        <p className={styles.hint}>Select a department to preview your starting team.</p>
      </div>
    );
  }

  if (isPending && members.length === 0) {
    return (
      <div className={styles.panel}>
        <p className={styles.label}>Your team preview</p>
        <div className={styles.pills}>
          <div className={styles.skeleton} />
          <div className={styles.skeleton} />
          <div className={styles.skeleton} />
        </div>
      </div>
    );
  }

  if (members.length === 0) return null;

  return (
    <div className={styles.panel}>
      <p className={styles.label}>Your team preview</p>
      <div className={styles.pills}>
        {members.map((m: StarterPreviewMember) => (
          <div key={m.name} className={styles.pill}>
            <div className={styles.avatar}>{m.name.charAt(0).toUpperCase()}</div>
            <div className={styles.name}>{m.name}</div>
            {m.department ? <div className={styles.dept}>{m.department}</div> : null}
            {m.role ? <div className={styles.role}>{m.role}</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
